import React from 'react';
import Typography from '../../../components/atoms/typography';

export function newPrivacyPolicy({ numberStep }: { numberStep?: number }): JSX.Element {
    return (
        <>
            <Typography fontSize="5xl" fontWeight="bold">
                {`${numberStep}. POLÍTICA DE PRIVACIDADE`}
            </Typography>

            <Typography textAlign="justify" mt={4}>
                A Fretapp está comprometida com a proteção da privacidade de seus usuários em todas as plataformas. Esta Política de Privacidade detalha as informações que coletamos de você ao usar nosso aplicativo móvel "Fretapp" e nossos serviços online, explicando como essas informações são usadas, compartilhadas e protegidas.
            </Typography>

            <Typography fontWeight="bold" mt={4}>
                1. Coleta e Utilização de Informações
            </Typography>
            <Typography textAlign="justify">
                <strong>1.1 Informações dos Motoristas</strong>
                    <li>Dados pessoais como nome, CPF/CNPJ, telefone, e-mail e senha.</li>
                    <li>Documentos de habilitação, como CNH, e dados do veículo para verificação de adequação e autenticidade.</li>
                    <li>Dados bancários para transações financeiras.</li>
                <strong>1.2 Informações das Distribuidoras</strong>
                    <li>Dados cadastrais, atividades desempenhadas, informações fiscais e bancárias.</li>
                    <li>Dados de localização e cookies para melhorar a experiência de navegação.</li>
            </Typography>

            <Typography fontWeight="bold" mt={4}>
                2. Compartilhamento de Dados com Terceiros
            </Typography>
            <Typography textAlign="justify">
                Dados podem ser compartilhados com provedores de serviços terceirizados, respeitando rigorosas medidas de privacidade.
            </Typography>

            <Typography fontWeight="bold" mt={4}>
                3. Segurança dos Dados
            </Typography>
            <Typography textAlign="justify">
                Implementamos medidas de segurança robustas para proteger seus dados contra acesso não autorizado, alteração, divulgação ou destruição.
            </Typography>

            <Typography fontWeight="bold" mt={4}>
                4. Acesso e Controle das Informações Pessoais
            </Typography>
            <Typography textAlign="justify">
                Você tem direito ao acesso, correção, exclusão e portabilidade de seus dados, além da capacidade de restringir ou se opor ao seu processamento.
            </Typography>

            <Typography fontWeight="bold" mt={4}>
                5. Alterações na Política de Privacidade
            </Typography>
            <Typography textAlign="justify">
                A Fretapp se reserva o direito de modificar esta política. Os usuários serão notificados sobre quaisquer alterações significativas e terão a chance de revisar a política atualizada.
            </Typography>

            <Typography fontWeight="bold" mt={4}>
                6. Contato
            </Typography>
            <Typography textAlign="justify">
                Para dúvidas ou preocupações sobre nossa Política de Privacidade, contate-nos em suporte@fretapp.com.
            </Typography>
        </>
    );
}
